import React, { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { langLabel } from "../_helpers/language";
import { LANG_LIST } from "../_constants";

import ruFlag from "../img/ru.png";
import enFlag from "../img/en.png";
import cnFlag from "../img/cn.png";

const FLAGS = { ru: ruFlag, en: enFlag, cn: cnFlag };

// Флаги в китайской сборке не показываем: там один язык интерфейса по умолчанию,
// а флаг России рядом с китайским текстом смотрится странно — так было и до списка.
const showFlags = process.env.REACT_APP_CHINA_MODE !== "true";

// Переключатель языка списком. Раньше кнопка перебирала языки по кругу
// (ru → en → cn → ru): какой станет следующим, было не видно, и с тремя языками
// человек в среднем дважды жал вслепую (пункт 59 QA-таблицы).
//
// Состояния языка компонент не держит — его меняет вызывающий: на публичных
// страницах это setState + свой i18next, в кабинете — Redux.
export function LangSwitch({ lang, onChange, labelStyle }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const pick = (item) => {
    setAnchorEl(null);
    if (item !== lang) onChange(item);
  };

  // На широких экранах body ужат через `zoom: 0.8` (src/style.css). MUI ставит
  // поповеру координаты из визуального getBoundingClientRect якоря, но портал
  // живёт внутри зумированного body, и координаты умножаются на zoom ещё раз —
  // список уезжает влево тем сильнее, чем правее кнопка (QA 08.26: на 1920px
  // смещение ~355px). MUI при этом клампит позицию к вьюпорту, поэтому
  // компенсировать якорь бесполезно — правим готовые top/left портала.
  // onEntering из пропов сюда не доходит (перебивается TransitionProps самого
  // Menu), поэтому следим за style через MutationObserver: MUI пишет координаты
  // и при открытии, и при ресайзе — каждый раз пересчитываем. Свою же правку
  // отличаем по dataset, иначе зациклимся.
  const attachZoomFixer = (node) => {
    if (!node || node.dataset.zoomObserver) return;
    node.dataset.zoomObserver = "1";
    const z = parseFloat(getComputedStyle(document.body).zoom) || 1;
    if (z === 1) return;
    const fix = () => {
      for (const prop of ["left", "top"]) {
        const v = parseFloat(node.style[prop]);
        if (Number.isNaN(v)) continue;
        const fixed = `${v / z}px`;
        if (node.style[prop] === fixed) {
          node.dataset[`last${prop}`] = fixed;
          continue;
        }
        if (node.dataset[`last${prop}`] === node.style[prop]) continue;
        node.dataset[`last${prop}`] = fixed;
        node.style[prop] = fixed;
      }
    };
    new MutationObserver(fix).observe(node, { attributeFilter: ["style"] });
  };

  return (
    <div className="lang">
      <button
        className="lang__btn"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {showFlags && FLAGS[lang] && (
          <img src={FLAGS[lang]} alt="" className="lang__flag" />
        )}
        <span style={labelStyle}>{langLabel(lang)}</span>
        {/* Стрелка — из MUI, а не из спрайта: спрайт подключается относительным
            путём и на вложенных маршрутах не находится, значок просто не рисуется. */}
        <ArrowDropDownIcon style={{ fontSize: 18, marginLeft: 2 }} />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ className: "lang-menu", ref: attachZoomFixer }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {LANG_LIST.map((item) => (
          <MenuItem key={item} selected={item === lang} onClick={() => pick(item)}>
            {showFlags && FLAGS[item] && (
              <img src={FLAGS[item]} alt="" className="lang__flag" />
            )}
            {langLabel(item)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default LangSwitch;
